import { render, staticRenderFns } from "./VersionAdd.vue?vue&type=template&id=7878fa68&"
import script from "./VersionAdd.vue?vue&type=script&lang=js&"
export * from "./VersionAdd.vue?vue&type=script&lang=js&"
import style0 from "./VersionAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports